import { useLayoutEffect, useState } from 'react'
import { themeChange } from 'theme-change'
import LocalStorage from 'utils/LocalStorageUtils.ts'

export enum Theme {
  LIGHT = 'light',
  DARK = 'night',
}

interface ThemeChangeReturn {
  currentTheme: Theme
  setCurrentTheme: (theme: Theme) => void
  toggleDarkMode: () => void
  themes: Theme[]
}

const useThemeChange = (): ThemeChangeReturn => {
  const [currentTheme, setCurrentTheme] = useState<Theme>(Theme.LIGHT)

  useLayoutEffect(() => {
    const localTheme = LocalStorage.getItem('theme')

    console.log('localTheme', localTheme)
    setHtmlDataTheme(localTheme ?? Theme.LIGHT)
    themeChange()
  }, [])

  useLayoutEffect(() => {
    LocalStorage.setItem('theme', currentTheme ?? Theme.LIGHT)
  }, [currentTheme])

  const setHtmlDataTheme = (theme: Theme): void => {
    document.documentElement.setAttribute('data-theme', theme)
    setCurrentTheme(theme)
  }

  const toggleDarkMode = (): void => {
    const newTheme = currentTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT
    setHtmlDataTheme(newTheme)
  }

  return {
    currentTheme,
    setCurrentTheme: setHtmlDataTheme,
    toggleDarkMode,
    themes: Object.values(Theme)
  }
}

export default useThemeChange
